import angular from 'angular';
import widgetsManagementRouting from './widgets-management-routing-module';
import WidgetsManagementComponent from './widgets-management-component';
import WidgetsEditComponent from './widgets-edit-component';

export default angular
  .module('widgets-management', [widgetsManagementRouting.name])
  .component('widgetsManagement', new WidgetsManagementComponent())
  .component('widgetsEdit', new WidgetsEditComponent());



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/components/widgets/widgets-management-module.js